<div class="container">
  <div class="offer-title">
    <p>
      {{ offerTitle }}
    </p>
  </div>
  <div class="current-plan-top-border"></div>
  <div class="new-plan-top-border"></div>

  <div
    class="current-plan"
    *ngFor="let planValues of currentPlan; let i = index"
  >
    <div *ngFor="let value of planValues; let even = even; let odd = odd">
      <p [ngClass]="{ cellvalueheader: even, cellvalue: odd }">{{ value }}</p>
    </div>
  </div>

  <div
    class="new-plan"
    [ngStyle]="styleObject(i + 3)"
    *ngFor="let planValues of newPlan; let i = index"
  >
    <div *ngFor="let value of planValues; let even = even; let odd = odd">
      <p [ngClass]="{ cellvalueheader: even, cellvalue: odd }">{{ value }}</p>
    </div>
  </div>

  <div class="offer-title feature-link">
    <dsa-cta [data]="features" (click)="onViewFeatures()"> </dsa-cta>
  </div>
</div>
